export const getNumberFromFilterPrimitive = (
    primitive: PreFilterPrimitive,
    defaultValue: number,
): number => {
    if (typeof primitive === 'number' && !Number.isNaN(primitive)) {
        return primitive;
    }

    let result = defaultValue;

    if (typeof primitive === 'string') {
        const parsedPrimitive = parseFloat(primitive);

        if (!Number.isNaN(parsedPrimitive)) {
            result = parsedPrimitive;
        }
    }

    return result;
};
